<template>
  <div class="container-wrap" :style="style">
    <div class="container">
      <div class="row">
        <div class="col">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colors from '@/services/colors'

export default {
  name: 'Container',
  props: {
    gray: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      return {
        backgroundColor: this.gray ? colors.gray : 'transparent'
      }
    }
  }
}
</script>


<style lang="scss" scoped>
  .container-wrap {
    padding-top: 100px;
    padding-bottom: 100px;
  }
</style>